import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { iconForField } from '../../../../common/custom/icon-library';
import TooltipInfo from '../../../../common/docs/TooltipInfo';

class FloatingModalProperties extends Component {
  FM_POSITION_OPTIONS_DESC = `
  <ul>
    <li>
      <b>Default -</b> Modal is automatic align during initialization.
    </li>
    <li>
      <b>Center -</b> Modal is automatic align to center.
    </li>
    <li>
      <b>Right -</b> Modal is automatic align to right.
    </li>
    <li>
      <b>Left -</b> Modal is automatic align to left.
    </li>
    <li>
      <b>Bottom -</b> Modal is automatic align to bottom.
    </li>
  </ul>
    `;

  fmPositionOptions = () => {
    let options = [
      { value: 'default', label: `Default` },
      { value: 'center', label: `Center` },
      { value: 'right', label: `Right` },
      { value: 'left', label: `Left` },
      { value: 'bottom', label: `Bottom` },
    ];
    return options;
  };

  render() {
    const { values, setFieldValue, setFieldTouched } = this.props;

    return (
      <div style={{ marginLeft: '30px' }}>
        <div className="form-group">
          <FormFieldWithLabel
            cta={false}
            label="Position"
            icon="select"
            infoIcon={true}
            infoDescription={this.FM_POSITION_OPTIONS_DESC}
          >
            <CustomSelect
              name={'fmPosition'}
              isMulti={false}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              options={this.fmPositionOptions()}
              value={values['fmPosition']}
            />
            <ErrorMessage name={'fmPosition'}>
              {(msg) => <p className="text-error">{msg}</p>}
            </ErrorMessage>
          </FormFieldWithLabel>
        </div>
        <div className="form-group">
          <FormFieldWithLabel
            cta={false}
            label="Height (px)"
            icon="number"
            infoIcon={true}
            infoDescription={`Enter Height`}
          >
            <Field
              type="number"
              min="1"
              name="fmHeight"
              className="form-control"
              placeholder="Enter Height (Default: 500)"
            />
          </FormFieldWithLabel>
        </div>
        <div className="form-group">
          <FormFieldWithLabel
            cta={false}
            label="Width (px)"
            icon="number"
            infoIcon={true}
            infoDescription={`Enter Width`}
          >
            <Field
              type="number"
              min="1"
              name="fmWidth"
              className="form-control"
              placeholder="Enter Width (Default: 500)"
            />
          </FormFieldWithLabel>
        </div>
        <div style={{ marginLeft: '15px' }}>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Draggable">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="fmDraggable"
                    className="form-check-input"
                    title="fmDraggable"
                  />
                  Draggable
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to allow dragging of the modal.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage name="fmDraggable" component="p" className="text-error ml-5" />
          </div>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Closable">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="fmClosable"
                    className="form-check-input"
                    title="fmClosable"
                  />
                  Closable
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to allow closing of the modal.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage name="fmClosable" component="p" className="text-error ml-5" />
          </div>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Resizable">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="fmResizable"
                    className="form-check-input"
                    title="fmResizable"
                  />
                  Resizable
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to allow resizing of the modal.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage name="fmResizable" component="p" className="text-error ml-5" />
          </div>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title="Minimizable">
                <span className="input-group-text">
                  <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                </span>
              </div>
              <div className="form-check">
                <label className="form-check-label">
                  <Field
                    type="checkbox"
                    name="fmMinimizable"
                    className="form-check-input"
                    title="fmMinimizable"
                  />
                  Minimizable
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </label>
              </div>
              <TooltipInfo
                title={`Enable it to allow minimizing of the modal.`}
                headerText={`What's this ?`}
                showHeader={true}
                showArrow={true}
                append={true}
              />
            </div>
            <ErrorMessage name="fmMinimizable" component="p" className="text-error ml-5" />
          </div>
        </div>
      </div>
    );
  }
}

export default FloatingModalProperties;
